import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[license-func-host]',
    standalone: false
})
export class LicenseFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}